export default "__VITE_PUBLIC_ASSET__b98e1b8f__"